import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isVisible: false,
    promptEvent: null,
};

const slice = createSlice({
    name: 'pwa',
    initialState,
    reducers: {
        setVisibility: (state, { payload: { isVisible } }) => ({
            ...state,
            isVisible,
        }),
        setLastDisplayedTimestamp: state => ({
            ...state,
            lastDisplayedTimestamp: new Date().toISOString(),
        }),
    },
});

export const { actions, name, reducer } = slice;
export const { setVisibility, setLastDisplayedTimestamp } = actions;
export default slice;
